import { CALL_API } from 'middleware/api';
import * as types from './types';
export const getExportTransactions = () => ({
    [CALL_API]: {
        endpoint: '/data-export/transactions',
        method: 'GET',
        types: [
            types.GET_EXPORT_TRANSACTIONS_REQUEST,
            types.GET_EXPORT_TRANSACTIONS_SUCCESS,
            types.GET_EXPORT_TRANSACTIONS_FAILURE,
        ],
    },
});
export const exportData = (body) => ({
    [CALL_API]: {
        endpoint: '/data-export',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        types: [
            types.EXPORT_DATA_REQUEST,
            types.EXPORT_DATA_SUCCESS,
            types.EXPORT_DATA_FAILURE,
        ],
    },
});
export const setLastSpacesInfoFetchTimestamp = (timestamp) => ({
    type: types.SET_LAST_SPACES_INFO_FETCH_TIMESTAMP,
    payload: timestamp,
});
export const setIsFetchingSpacesInfo = (isFetching) => ({
    type: types.SET_IS_FETCHING_SPACES_INFO,
    payload: isFetching,
});
